import { createFileRoute, notFound } from "@tanstack/react-router";
import Article from "@/pages/Article";
import NotFound from "@/pages/NotFound";
import { articleExists } from "@/lib/seo/exists.functions";
import { getSavedArticleTranslationByPath } from "@/lib/articleAi.functions";
import { DEFAULT_LOCALE, type Locale } from "@/i18n/config";

const TRANSLATION_CODE: Partial<Record<Locale, string>> = { no: "no", "zh-Hant": "zh-Hant" };

export const Route = createFileRoute("/_app/article/$id")({
  loader: async ({ params, context }) => {
    const exists = await articleExists({ data: params.id });
    if (!exists) throw notFound();

    // Load the reader's language on the server so the page never paints in
    // English first and swaps a moment later.
    const locale =
      (context as { localeRef?: { current: Locale } }).localeRef?.current ?? DEFAULT_LOCALE;
    const language = TRANSLATION_CODE[locale];
    if (!language) return { translation: null, language: "en" as const };
    try {
      const saved = await getSavedArticleTranslationByPath({ data: { path: params.id, language } });
      return { translation: saved?.translation ?? null, language };
    } catch {
      return { translation: null, language };
    }
  },
  notFoundComponent: NotFound,
  component: () => <Article />,
});
